import React from 'react';
import classNames from 'classnames';
import styles from './hamburgerIcon.scss';

function HamburgerIcon({ onClick, isCrossed, className = '' }) {
  return (
    <button
      className={`${styles.hamburgerIcon} ${className}`}
      onClick={onClick}
    >
      <div className={styles.icon}>
        <div
          className={classNames({
            [styles.line]: true,
            [styles.cross1]: isCrossed,
          })}
        />
        <div
          className={classNames({
            [styles.line]: true,
            [styles.cross2]: isCrossed,
          })}
        />
        <div
          className={classNames({
            [styles.line]: true,
            [styles.cross3]: isCrossed,
          })}
        />
      </div>
    </button>
  );
}

export default HamburgerIcon;
